import {MEDIA, SLIDER} from "../../constants";

const changeSlide = (isScrollDirectionDown) => {
	if (window.innerWidth >= MEDIA.DESKTOP)
	{
		const currentSlide = SLIDER.HEADER_ANCHORS.find((anchor) => anchor.classList.contains(`current`));
		const currentSlideIndex = SLIDER.HEADER_ANCHORS.indexOf(currentSlide);
		const nextSlide = currentSlideIndex === -1 ? false : currentSlideIndex + 1 <= SLIDER.HEADER_ANCHORS.length - 1 && isScrollDirectionDown ? SLIDER.HEADER_ANCHORS[currentSlideIndex + 1] : currentSlideIndex - 1 >= 0 && !isScrollDirectionDown ? SLIDER.HEADER_ANCHORS[currentSlideIndex - 1] : false;

		nextSlide ? nextSlide.click() : false;
	}
};

const isContentScrolled = (target, isScrollDirectionDown) => {
	if (target)
	{
		const content = target.querySelector(`div`);
		const contentCurrentScroll = content.scrollTop;
		const contentVisibleHeight = content.offsetHeight;
		const contentFullHeight = content.scrollHeight;

		const isScrollBottomEnd = contentCurrentScroll + contentVisibleHeight === contentFullHeight;
		const isScrollTopEnd = contentCurrentScroll === 0;

		return isScrollDirectionDown ? isScrollBottomEnd : isScrollTopEnd;
	}

	return true;
};

export const initTouch = () => {
	const TouchProperties = {
		coords: {},
		aside: null,
		textWrapper: null,
	};
	
	window.addEventListener( `touchstart`, function (startEvt) {
		TouchProperties.coords.start = {
			x: startEvt.touches[0].clientX,
			y: startEvt.touches[0].clientY,
		};

		TouchProperties.coords.move = {
			x: 0,
			y: 0,
		};

		TouchProperties.coords.end = {
			x: 0,
			y: 0,
		};
		
		TouchProperties.aside = startEvt.target.closest(`aside`);
		TouchProperties.textWrapper = startEvt.target.closest(`div.text-wrapper`);
	}, {passive: false});

	window.addEventListener(`touchmove`, (moveEvt) => {
		TouchProperties.coords.move = {
			x: moveEvt.touches[0].clientX,
			y: moveEvt.touches[0].clientY,
		};

		TouchProperties.coords.end = {
			x: TouchProperties.coords.move.x - TouchProperties.coords.start.x,
			y: TouchProperties.coords.move.y - TouchProperties.coords.start.y,
		};

		let isAsideScrolled = true;
		if (TouchProperties.aside)
		{
			const test1 = TouchProperties.aside.querySelector(`div.content`).scrollTop === 0;
			const test2 = TouchProperties.coords.end.y > 0;
			const test3 = TouchProperties.aside.querySelector(`div.content`).scrollTop === TouchProperties.aside.querySelector(`div.content`).scrollHeight - TouchProperties.aside.querySelector(`div.content`).offsetHeight;
			const test4 = TouchProperties.coords.end.y < 0;

			isAsideScrolled = ( test1 && test2 ) || ( test3 && test4 );
		}
		
		if (window.innerWidth >= MEDIA.DESKTOP && isContentScrolled(TouchProperties.textWrapper, TouchProperties.coords.end.y < 0) && (!TouchProperties.aside || isAsideScrolled) )
		{
			moveEvt.preventDefault();
		}
	}, {passive: false});

	window.addEventListener( `touchend`, function (startEvt) {
		if (!TouchProperties.aside && Math.abs(TouchProperties.coords.end.y) > 50 && isContentScrolled(TouchProperties.textWrapper, TouchProperties.coords.end.y < 0))
		{
			changeSlide(TouchProperties.coords.end.y < 0);
		}
	}, {passive: false});
};
